import React from "react";
import styled from "styled-components";
import Column from "../Column/Column";
const HiddenRadio = styled.input.attrs({ type: "radio" })`
  // Hide checkbox visually but remain accessible to screen readers.
  // Source: https://polished.js.org/docs/#hidevisually
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
const Icon = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #03bbf5;
`;
const StyledRadio = styled("div")<{ checked: boolean, error: boolean }>`
  position: relative;
  display: inline-block;
  text-align: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: ${(props) =>
    props.checked ? "2px solid #03BBF5" : props.error ?"2px solid #FB4EFF" : '2px solid white'};
  transition: all 150ms;

  ${Icon} {
    visibility: ${(props) => (props.checked ? "visible" : "hidden")};
  }
`;
const RadioContainer = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

interface RadioProps {
  selected: string;
  radioOptions: string[];
  error?: boolean;
  onChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const RadioOptions: React.FC<RadioProps> = ({
  selected,
  onChanged,
  radioOptions,
  error
}) => (
  <Column style={{ gap: "10px" }}>
    {radioOptions.map((radioOption) => (
      <label key={radioOption}>
        <RadioContainer>
          <HiddenRadio
            checked={selected === radioOption}
            onChange={onChanged}
            name={radioOption}
          />
          <StyledRadio checked={selected === radioOption} error={error}>
            <Icon />
          </StyledRadio>
          <span style={{ marginLeft: 8 }}>{radioOption}</span>
        </RadioContainer>
      </label>
    ))}
  </Column>
);
export default RadioOptions;
